// Enum for Connection Type
export enum ConnectionTypeEnum {
    DrogeVerbinding = 'Droge verbinding',
    VerbindingMetToegevoegdeElementen = 'Verbinding met toegevoegde elementen',
    DirecteIntegraleVerbinding = 'Directe integrale verbinding',
    ZachteChemischeVerbinding = 'Zachte chemische verbinding',
    HardeChemischeVerbinding = 'Harde chemische verbinding'
}

// Enum for Connection Accessibility
export enum ConnectionAccessibilityEnum {
    FreeAccessWithoutActions = 'Vrij toegankelijk zonder extra handelingen',
    AccessibleWithNoHarmfulActions = 'Toegankelijk met extra handelingen die geen schade veroorzaken',
    AccessibleWithFullyRestorableDamage = 'Toegankelijk met extra handelingen met volledig herstelbare schade',
    AccessibleWithPartiallyRestorableDamage = 'Toegankelijk met extra handelingen met gedeeltelijk herstelbare schade',
    NotAccessibleUnrecoverableDamage = 'Niet toegankelijk - onherstelbare schade aan het product of omliggende producten'
}

// Enum for Piercing
export enum PiercingEnum {
    NoCrossings = 'Geen doorkruisingen - modulaire zonering van producten of elementen uit verschillende lagen',
    IncidentalCrossings = 'Incidentele doorkruisingen van producten of elementen uit verschillende lagen',
    FullIntegration = 'Volledige integratie van producten of elementen uit verschillende lagen'
}

// Enum for Edge Enclosure
export enum EdgeEnclosureEnum {
    OpenNoObstruction = 'Open, geen belemmering voor het (tussentijds) uitnemen van producten of elementen',
    PartialObstruction = 'Overlapping, gedeeltelijke belemmering voor het (tussentijds) uitnemen van producten of elementen',
    ClosedCompleteObstruction = 'Gesloten, volledige belemmering voor het (tussentijds) uitnemen van producten of elementen'
}